<template>
  <div class="danmu">
    <vue-baberrage
      :isShow= "liveBtnList.barrageOnOff"
      :boxWidth= "danmu.boxWidth"
      :lanesCount = 3
      :barrageList = "danmu.barrageList"
      :loop = "danmu.barrageLoop">
      <template v-slot:default="slotProps">
        <span :style="danmu.barrageStyle + ';font-size:16px'" v-html="emojiFilter(slotProps.item.msg)">
        </span>
      </template>
    </vue-baberrage>
   </div>
</template>

<script>
import { MESSAGE_TYPE } from 'vue-baberrage'

export default {
  name: 'baberrage',
  props: {
    liveBtnList: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      danmu: {
        boxWidth: 0,
        barrageLoop: false,
        currentId: 0,
        time: 0,
        barrageStyle: 'color:#fff',
        barrageList: []
      },
      EmotionList: ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭',
        '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '可爱',
        '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问', '嘘',
        '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼',
        '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒',
        '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹',
        '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引',
        '拳头', '差劲', '爱你', 'NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '挥手',
        '激动', '街舞', '献吻', '左太极', '右太极']
    }
  },
  created () {
    this.danmu.boxWidth = window.screen.width
    this.danmu.time = this.danmu.boxWidth / 148
  },
  computed: {
    count () {
      return this.$store.state.live.baberrage.id
    }
  },
  watch: {
    count (val) {
      this.addToList(this.$store.state.live.baberrage)
    }
  },
  methods: {
    addToList (baberrage) {
      if (baberrage.type === 1) {
        this.danmu.barrageStyle = 'color:#d7b76d'
      }
      this.danmu.barrageList.push({
        id: ++this.danmu.currentId,
        msg: baberrage.msg,
        time: this.danmu.time,
        barrageStyle: this.danmu.barrageStyle,
        type: MESSAGE_TYPE.NORMAL
      })
    },
    // 校验表情
    emojiFilter (text) {
      const vueThat = this
      return text.replace(/\[([^\]]+)\]/g, (words) => {
        words = words.replace('[', '')
        words = words.replace(']', '')
        console.log(words)
        const index = vueThat.EmotionList.indexOf(words)
        if (index !== -1) {
          return `<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${index}.gif" style="width: 20px; height: 20px;margin: 0 1px">`
        } else {
          return words
        }
      })
    }
  }
}
</script>

<style>
</style>
